import React from 'react';
import { styled } from '@mui/system';
import CircularProgress, {
	circularProgressClasses,
	CircularProgressProps,
} from '@mui/material/CircularProgress';
import { RiCheckLine } from 'react-icons/ri';
import { Box } from '@mui/material';

type Props = CircularProgressProps & { spin?: boolean };

const ProgressCircle = (props: Props) => {
	return (
		<StyledBoxWrapper>
			<StyledCircleWrapper sx={{ transform: `scale(${props.value === 100 ? 0 : 1})` }}>
				<CircularProgress
					variant="determinate"
					sx={{
						color: (theme) => theme.palette.primary.lightest,
					}}
					size={20}
					thickness={4}
					{...props}
					value={100}
				/>
				<CircularProgress
					sx={{
						color: (theme) => theme.palette.primary.main,
						animationDuration: '550ms',
						position: 'absolute',
						left: 0,
						[`& .${circularProgressClasses.circle}`]: {
							strokeLinecap: 'round',
						},
					}}
					variant={props.spin ? 'indeterminate' : 'determinate'}
					size={20}
					thickness={4}
					{...props}
				/>
			</StyledCircleWrapper>

			<StyledIconContainer sx={{ opacity: props.value === 100 ? 1 : 0 }}>
				<RiCheckLine size={32} />
			</StyledIconContainer>
		</StyledBoxWrapper>
	);
};

const StyledBoxWrapper = styled(Box)(() => ({
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: 32,
	height: 32,
}));

const StyledCircleWrapper = styled(Box)(() => ({
	position: 'absolute',
	top: 6,
	left: 6,
	bottom: 6,
	right: 6,
	transition: 'transform 0.2s',
	transitionDelay: '550ms',
	zIndex: 1,
}));

const StyledIconContainer = styled(Box)(({ theme }) => ({
	position: 'absolute',
	top: 5,
	left: 5,
	bottom: 5,
	right: 5,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: theme.palette.primary.main,
	borderRadius: '50%',
	zIndex: 2,
	transition: 'opacity 0.2s',
	transitionDelay: '550ms',
}));

export default ProgressCircle;
